import {useCustomQuery} from '@salesforce/commerce-sdk-react'

/**
 * Hook to fetch newsletter checkbox default state from custom preferences
 * @returns {boolean} - Whether newsletter checkbox should be pre-checked
 */
export const useNewsletterPreference = () => {
    const {data, isLoading} = useCustomQuery({
        options: {
            method: 'GET',
            customApiPathParameters: {
                apiVersion: 'v1',
                endpointPath: 'newsletter-checkbox',
                apiName: 'preferences'
            }
        },
        rawResponse: false
    })

    return {
        isNewsletterPreChecked: data?.isNewsletterPreChecked ?? false,
        isLoading
    }
}
